export default Object.freeze({
    TODO: 'toDo',
    IN_PROGRESS: 'inProgress',
    SUBMITTED: 'submitted',
    APPROVED: 'approved',
    SENT: 'sent',
});
